// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ig-c";
export var backButton = "_ig-4";
export var backIcon = "_ig-5";
export var chevronShortcut = "_ig-6";
export var container = "_ig-1";
export var editor = "_ig-8";
export var editorWrapper = "_ig-7";
export var prefix = "_ig-2";
export var searchIcon = "_ig-3";
export var suffix = "_ig-9";
export var suffixContent = "_ig-a";
export var suffixText = "_ig-b";
export var wrapper = "_ig-0";